import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import NullComponent from 'Components/UI/NullComponent';

const Collection = ({
  metaField,
  resource,
  attrName,
  CustomProps,
}) => {
  const Component = metaField.attr('_component');

  if (metaField.attr('hidden')) {
    return NullComponent;
  }
  if (!Component) {
    return NullComponent;
  }
  return <Component collection={resource.attr(attrName)} {...CustomProps} />;
};

Collection.propTypes = {
  metaField: PropTypes.object.isRequired,
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
  attrName: PropTypes.string.isRequired,
  CustomProps: PropTypes.object.isRequired,
};

export default Collection;
